$(document).ready(function () {
    $(document).on('submit', '.form-print', function (e) {

        e.preventDefault();

        let uuid = $(this).find('input[name="uuid"]').val();
        let route = $(this).find('input[name="route"]').val();

        let src = '/print-return?uuid=' + encodeURIComponent(uuid);
        console.log(src)
        let iframe = document.getElementById('printFrame');

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'printFrame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        iframe.src = src;

        iframe.onload = function () {
            iframe.contentWindow.print();
        };
    });


    $(document).on('submit', '.form-print-package-list', function (e) {

        e.preventDefault();

        let uuid = $(this).find('input[name="uuid"]').val();
        let src = '/print-detail-by-package?uuid=' + encodeURIComponent(uuid);
        console.log(src)
        let iframe = document.getElementById('printFrame');

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'printFrame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        iframe.src = src;

        iframe.onload = function () {
            iframe.contentWindow.print();
        };
    });

    $(document).on('submit', '.form-print-total', function (e) {

        e.preventDefault();

        let formData = new FormData(this);
        let params = new URLSearchParams();

        for (let pair of formData.entries()) {
            params.append(pair[0], pair[1]);
        }

        let src = '/print-total?' + params.toString();
        console.log(src);

        let iframe = document.getElementById('printFrame');

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'printFrame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        iframe.src = src;

        iframe.onload = function () {
            iframe.contentWindow.print();
        };
    });

    $('.show-modal-print-total').on('click', function (e) {
        e.preventDefault();
        console.log("Mi Maky")
        $('.modal-print-total').find('.chosen-select').chosen('destroy').chosen({
            width: '100%',
            no_results_text: "No se encontraron resultados para"
        });
        $('.modal-print-total').modal('show');
    });
})


